<template>
  <b-overlay :show="isLoading">
    <SelectComponent
        :options="exams | idNameToValueLabel"
        :disabled="disabled"
        :searching="isLoading"
        :model="model"
        @search="autocomplete"
        @input="evt => $emit('input', evt)"
    />
  </b-overlay>
</template>

<script>
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "SelectTuevsExam",
  components: {SelectComponent},
  props: {
    model: null,
    disabled: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'tuevs/exams/isLoading',
      exams: 'tuevs/exams/all',
    })
  },
  data() {
    return {
      awaitingSearch: false
    }
  },
  methods: {
    ...mapActions([
      'tuevs/exams/search',
    ]),
    async autocomplete(string) {
      if (string.length >= 3 && !this.awaitingSearch) {
        setTimeout(async () => {
          let filterConcat = [...(this.filters ?? []), ...[['name', 'LIKE', '%' + string + '%']]]
          await this['tuevs/exams/search']({filters: filterConcat})
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    }
  },
  mounted() {
    this['tuevs/exams/search']({filters: this.filters})
  }
}
</script>

<style lang="scss" scoped>
</style>